import React from 'react';

const Clients = () => {
    return (
        <div className="mt-8 bg-gray-100">
            <section data-aos="fade-up">
                <div className="my-4 py-4">
                    <h2 className="my-2 text-center text-3xl text-blue-900 uppercase font-bold">Certifications &amp; Compliance</h2>
                    <div className='flex justify-center'>
                        <div className='w-24 border-b-4 border-blue-900'></div>
                    </div>
                    <p className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-blue-900">
                        Built to international safety and quality standards.
                    </p>
                </div>

                {/* Certification badges */}
                <div className="p-8 max-w-3xl mx-auto" data-aos="fade-in" data-aos-delay="400">
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
                        {[
                            { label: 'CE', sub: 'European Conformity', color: 'text-gray-900', bg: 'bg-white' },
                            { label: 'RoHS', sub: 'Hazardous Substance Free', color: 'text-green-700', bg: 'bg-white' },
                            { label: 'FCC', sub: 'FCC Authorized', color: 'text-orange-500', bg: 'bg-white' },
                            { label: 'UKCA', sub: 'UK Conformity Assessed', color: 'text-blue-900', bg: 'bg-white' },
                        ].map((cert) => (
                            <div key={cert.label} className={`${cert.bg} rounded-2xl shadow-md p-6 flex flex-col items-center justify-center border-2 border-gray-100 hover:border-blue-300 transition-all duration-300`}>
                                <span className={`text-3xl font-black ${cert.color}`}>{cert.label}</span>
                                <span className="text-xs text-gray-500 text-center mt-1 font-medium">{cert.sub}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Product specs bar */}
                <div className="max-w-4xl mx-auto px-8 pb-12" data-aos="fade-up" data-aos-delay="600">
                    <div className="bg-blue-900 rounded-2xl p-6 text-white">
                        <h3 className="text-center text-lg font-bold mb-4 text-blue-200 uppercase tracking-widest text-sm">Technical Specifications</h3>
                        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 text-center">
                            {[
                                { label: 'Model', value: 'AT-29384' },
                                { label: 'Version', value: '5.2' },
                                { label: 'Bluetooth', value: '4.0 BLE' },
                                { label: 'Protocols', value: '9 (All OBDII)' },
                                { label: 'Voltage', value: '12V (Universal)' },
                            ].map((spec) => (
                                <div key={spec.label} className="bg-blue-800 bg-opacity-60 rounded-xl p-3">
                                    <p className="text-blue-300 text-xs font-semibold uppercase tracking-wide mb-1">{spec.label}</p>
                                    <p className="text-white font-bold text-sm">{spec.value}</p>
                                </div>
                            ))}
                        </div>
                        <div className="mt-4 text-center">
                            <p className="text-blue-300 text-xs">Made in China · Assembled with Pride for AllyTopic Inc. · 1-Year Warranty (registration required)</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Clients;
